import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import MainLayout from "../../layouts/Main";
import { AssessmentStartup } from "../../sub_components/assessment/Startup";
import { AssessmentsListTable } from "../../sub_components/assessment/ListTable";
import { SVGIcon } from "../../wrappers/SVGIcon";

import { ISortQuery } from "../../../interfaces/services";

import { useGetAssessments } from "../../../hooks/assessments";

import { Icons } from "../../../data/Assets";

const AssessmentsPage = () => {
    const navigate = useNavigate();

    const [sortQuery, setSortQuery] = useState<ISortQuery>({ sort_key: 'title', sort_order: 'ASC' });

    const { data: assessments, isLoading } = useGetAssessments(sortQuery);

    return (
        <MainLayout>
            {
                !assessments?.length
                    ? <AssessmentStartup />
                    : <div className="immployer__lists__page_view">
                        <h2 className="color_dark">Assessments</h2>
                        <br /><br />
                        <div className="immployer__lists__top_section">
                            <button
                                onClick={() => navigate('/assessments/new')}
                                className="immployer__btn immployer__btn__primary"
                            >
                                <SVGIcon src={Icons.Plus} color='white' />
                                <span>Add&nbsp;Role</span>
                            </button>
                        </div>
                        <AssessmentsListTable
                            isLoading={isLoading}
                            assessments={assessments ?? []}
                            sortQuery={sortQuery}
                            setSortQuery={setSortQuery}
                        />
                    </div>
            }
        </MainLayout>
    );
};

export default AssessmentsPage;